import SearchPageError from './SearchPageError';

export default SearchPageError;
